// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-actions-index-list-bwmtt{display:grid;grid-gap:24px}.pages-actions-index-list-bwmtt.pages-actions-index-desktop-bmbni{grid-template-columns:repeat(4,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "pages-actions-index-list-bwmtt",
	"desktop": "pages-actions-index-desktop-bmbni"
};
module.exports = ___CSS_LOADER_EXPORT___;
